import * as constants from '../constants';

export default function(state = [], action) {
  switch (action.type) {
    case constants.GET_PLACES_SUCCESS:
      return Object.assign({}, state, {
        places: action.places.data || [],
        isRefreshRequired: false,
      });
    case constants.POST_PLACE_SUCCESS:
    case constants.PATCH_PLACE_SUCCESS:
      return Object.assign({}, state, {
        isRefreshRequired: true,
      });
    case constants.GET_PLACE_SUCCESS:
      return Object.assign({}, state, {
        place: action.place.data || {},
        isRefreshRequired: false,
      });
    case constants.GET_PLACES_ERROR:
    case constants.GET_PLACE_ERROR:
    case constants.POST_PLACE_ERROR:
    case constants.PATCH_PLACE_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
